import { APP_MAPPING_PERMISSIONS, APP_MODULES } from "../constants";

export const PermissionUtil = {
  getModulePermisstionByEmail,
};

function getModulePermisstionByEmail(email: string): APP_MODULES[] {
  let modules: APP_MODULES[] = APP_MAPPING_PERMISSIONS[email];

  if (!modules) {
    modules = Object.values(APP_MODULES) as APP_MODULES[];
  }

  return modules;
}
